module.exports = __webpack_public_path__ + "img/num.dc60c97d.svg";